import gql from "graphql-tag";

const StaffLeaveProps = gql`
    fragment StaffLeaveProps on StaffLeave {
        id
        startDate
        endDate
        note
        approved {
            status
            note
            author {
                id
                first_name
                surname
                middle_name
                designation {
                    id
                    name
                }
            }
        }
        declined {
            status
            note
            author {
                id
                first_name
                surname
                middle_name
                designation {
                    id
                    name
                }
            }
        }
        created_at
        returned {
            status
            note
            author {
                id
                first_name
                surname
                middle_name
                designation {
                    id
                    name
                }
            }
        }
        days
        onLeave
    }
`;

export const GET_STAFF_LEAVE = gql`
    query GetStaffLeave {
        GetStaffLeaves {
            docs {
                ...StaffLeaveProps
            }
        }
    }
    ${StaffLeaveProps}
`;

export const NEW_STAFF_LEAVE = gql`
    mutation NewStaffLeave($model: StaffLeaveInput!) {
        NewStaffLeave(model: $model) {
            message
            doc {
                ...StaffLeaveProps
            }
        }
    }
    ${StaffLeaveProps}
`;

export const GET_LEAVE_ALL_STAFF = gql`
    query GetAllStaffLeave($page: Int, $limit: Int) {
        GetAllStaffLeaveList(page: $page, limit: $limit) {
            docs {
                ...StaffLeaveProps
                staff {
                    id
                    first_name
                    surname
                    middle_name
                    designation {
                        id
                        name
                    }
                }
            }
            page
            limit
            totalDocs
            totalPages
            nextPage
            prevPage
        }
    }
    ${StaffLeaveProps}
`;

export const APPROVE_LEAVE = gql`
    mutation ApproveStaffLeave($id: ID!, $note: String) {
        ApproveStaffLeave(id: $id, note: $note) {
            message
            doc {
                ...StaffLeaveProps
            }
        }
    }
    ${StaffLeaveProps}
`;

export const DECLINE_LEAVE = gql`
    mutation DeclineStaffLeave($id: ID!, $note: String) {
        DeclineStaffLeave(id: $id, note: $note) {
            message
            doc {
                ...StaffLeaveProps
            }
        }
    }
    ${StaffLeaveProps}
`;
export const ACCEPT_LEAVE = gql`
    mutation AcceptLeaveReturn($id: ID!, $note: String) {
        AcceptLeaveReturn(id: $id, note: $note) {
            message
            doc {
                ...StaffLeaveProps
            }
        }
    }
    ${StaffLeaveProps}
`;
